<template>
  <div class="exhibitors-popup">
    <div class="container-fluid mymeeting_new_wpapper">
      <!--<div><h4 style="color: #000; margin-top: 10px">My Meetings</h4></div>-->
      <div class="sponsors-inner-hld attendee-list d-flex meeting-list">
        <!---tab content---->
        <div class="full-width">
          <div
            v-if="attendeeData.length == 0"
            class="ex-no-meeting-wrap"
            style="height: 524px"
          >
            <p class="text-center ex-no-meeting-text m-0 mb-2">
              There are no Live or Upcoming Confirmed meetings.
            </p>
            <v-btn
              v-show="allowRequestMeeting"
              small
              color="#19a883"
              dark
              class="m0"
              @click="goToBookAppointment"
              >Book New Meeting<v-icon dark>mdi-chevron-right</v-icon></v-btn
            >
          </div>
          <!----Confirmed tab start--------->
          <div
            v-else-if="!rightPanel"
            class="tab-pane active"
            id="Confirmed"
            style="
              height: 524px;
              padding-right: 5px;
              overflow-x: hidden;
              overflow-y: auto;
              padding: 15px 25px;
            "
          >
            <div class="">
              <div
                class="col-md-6 col-lg-4 meeting-box-hld listing-view-box"
                v-for="(attendee, index) in attendeeData"
                :key="attendee.id"
              >
                <div
                  v-if="
                    attendee.MeetingCurrentStatus === 'Live' ||
                    attendee.MeetingCurrentStatus === 'Upcoming'
                  "
                  v-bind:class="[
                    attendee.MeetingCurrentStatus === 'Meeting Ended'
                      ? 'dvtoShow'
                      : 'dvtoShow',
                  ]"
                >
                  <div
                    v-if="
                      (attendee.ReceiverId == uid ||
                        attendee.SenderId == uid) &&
                      attendee.Status == 'Accepted'
                    "
                    class="sponsors-box-hld py-2"
                  >
                    <div
                      v-if="attendee.ReceiverId == uid"
                      class="
                        d-flex
                        align-items-start
                        top-img-box
                        full-width
                        justify-content-between
                      "
                      data-toggle="modal"
                      v-bind:data-target="'#Attendee' + index"
                      data-tag="MeetingsAttendeeDetailsPopup"
                    >
                      <div
                        class="d-flex justify-content-start align-items-center"
                      >
                        <span
                          v-if="
                            attendee.Organizerprofilepic !== undefined &&
                            attendee.Organizerprofilepic.length > 0
                          "
                          class="attendee-img-area"
                        >
                          <img
                            v-bind:src="attendee.Organizerprofilepic"
                            v-bind:alt="attendee.OrganizerFname"
                          />
                        </span>
                        <span v-else class="attendee-img-area">{{
                          attendee.OrganizerAttendeesInitials
                        }}</span>

                        <div class="grey-bg-texthld">
                          <h3>{{ attendee.Organizername }}</h3>
                          <p
                            v-if="
                              attendee.OrganizerCompany ||
                              attendee.OrganizerCompany
                            "
                          >
                            {{
                              attendee.OrganizerTitle +
                              (attendee.OrganizerCompany &&
                              attendee.OrganizerCompany
                                ? ", "
                                : "") +
                              attendee.OrganizerCompany
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="session-status pt-0">
                        <p>
                          <span
                            class="finish-session"
                            :style="
                              attendee.MeetingCurrentStatus === 'Live'
                                ? 'background-color:#00a982;'
                                : attendee.MeetingCurrentStatus === 'Upcoming'
                                ? 'background-color:#FFC300;'
                                : ''
                            "
                          ></span>
                          {{ attendee.MeetingCurrentStatus == "Meeting Ended"?"Ended":attendee.MeetingCurrentStatus }}
                        </p>
                      </div>
                    </div>

                    <div
                      v-if="attendee.SenderId == uid"
                      class="
                        d-flex
                        align-items-start
                        top-img-box
                        full-width
                        justify-content-between
                      "
                      data-toggle="modal"
                      v-bind:data-target="'#Attendee' + index"
                      data-tag="MeetingsAttendeeDetailsPopup"
                    >
                      <div
                        class="d-flex justify-content-start align-items-center"
                      >
                        <span
                          v-if="
                            attendee.Image !== undefined &&
                            attendee.Image.length > 0
                          "
                          class="attendee-img-area"
                        >
                          <img
                            v-bind:src="attendee.Image"
                            v-bind:alt="attendee.Name"
                          />
                        </span>
                        <span v-else class="attendee-img-area">{{
                          attendee.AttendeeInitials
                        }}</span>

                        <div class="grey-bg-texthld">
                          <h3>{{ attendee.Name }}</h3>
                          <p v-if="attendee.Title || attendee.Company">
                            {{
                              attendee.Title +
                              (attendee.Title && attendee.Company ? ", " : "") +
                              attendee.Company
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="session-status pt-0">
                        <p>
                          <span
                            class="finish-session"
                            :style="
                              attendee.MeetingCurrentStatus === 'Live'
                                ? 'background-color:#00a982;'
                                : attendee.MeetingCurrentStatus === 'Upcoming'
                                ? 'background-color:#FFC300;'
                                : ''
                            "
                          ></span>
                          {{ attendee.MeetingCurrentStatus == "Meeting Ended"?"Ended":attendee.MeetingCurrentStatus }}
                        </p>
                      </div>
                    </div>

                    <div class="status redsn-evnts-col bottom-line">
                      <article style="margin-left: 70px">
                        <ul class="p-0">
                          <li>
                            <h5 class="ico-calender-sm">
                              {{ attendee.StartDate }}
                            </h5>
                          </li>
                          <li>
                            <p class="ico-pin-sm">{{ attendee.StartTime }}</p>
                          </li>
                        </ul>
                      </article>
                      <div class="calender-icon-hld">
                        <p class="m-0 pl-0">Add to Calendar</p>
                        <ul class="d-flex align-items-center">
                          <li>
                            <a
                              v-bind:href="AddToGoogleCalendar(attendee, 1)"
                              target="_blank"
                            >
                              <span>
                                <img
                                  src="../assets/Images/icons/google-icon.svg"
                                  alt="google-icon"
                                />
                              </span>
                            </a>
                          </li>
                          <li>
                            <a
                              v-bind:href="AddToOutlookCalendar(attendee, 1)"
                              target="_blank"
                            >
                              <span>
                                <img
                                  src="../assets/Images/icons/outlook.svg"
                                  alt="outlook-icon"
                                />
                              </span>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div class="button-area text-right">
                        <button
                          :disabled="attendee.MeetingCurrentStatus !== 'Live'"
                          v-if="
                            attendee.ReceiverId == uid &&
                            attendee.Status == 'Accepted'
                          "
                          v-on:click="
                            StartBroadcast(
                              attendee.MeetingId,
                              attendee.StreamingClient
                            );
                            return false;
                          "
                          :style="
                            attendee.MeetingCurrentStatus !== 'Live'
                              ? 'background-color:#eee; color:#000;'
                              : ''
                          "
                          :class="
                            attendee.MeetingCurrentStatus === 'Live'
                              ? 'btn-rounded j-meeting-btn'
                              : attendee.MeetingCurrentStatus === 'Upcoming'
                              ? 'btn-rounded j-meeting-btn disable-slot'
                              : 'btn-rounded j-meeting-btn disable-slot'
                          "
                          data-tag="joinMeeting"
                        >
                          {{ $t("mymeetings.joinmeeting") }}
                        </button>

                        <button
                          :disabled="attendee.MeetingCurrentStatus !== 'Live'"
                          v-if="
                            attendee.SenderId == uid &&
                            attendee.Status == 'Accepted'
                          "
                          v-on:click="
                            StartBroadcast(
                              attendee.MeetingId,
                              attendee.StreamingClient
                            );
                            return false;
                          "
                          :style="
                            attendee.MeetingCurrentStatus !== 'Live'
                              ? 'background-color:#eee; color:#000;'
                              : ''
                          "
                          :class="
                            attendee.MeetingCurrentStatus === 'Live'
                              ? 'btn-rounded j-meeting-btn'
                              : attendee.MeetingCurrentStatus === 'Upcoming'
                              ? 'btn-rounded j-meeting-btn disable-slot'
                              : 'btn-rounded j-meeting-btn disable-slot'
                          "
                          data-tag="joinMeeting"
                        >
                          {{ $t("mymeetings.joinmeeting") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            id="Confirmed"
            class="tab-pane active right-panel"
            style="padding-right: 5px; overflow-x: hidden; padding: 0"
          >
            <div class="">
              <div
                v-for="(attendee, index) in attendeeData"
                :key="attendee.id"
                class="col-md-6 col-lg-4 meeting-box-hld listing-view-box"
                style="border-radius: 8px"
                v-show="attendee.Status == 'Accepted'"
              >
                <div
                  v-if="
                    currentMeetingId == attendee.MeetingId ||
                    attendee.MeetingCurrentStatus === 'Live' ||
                    attendee.MeetingCurrentStatus === 'Upcoming'
                  "
                  class="dvtoShow"
                >
                  <div class="border-0 sponsors-box-hld py-2">
                    <div
                      v-if="attendee.ReceiverId == uid"
                      class="
                        d-flex
                        align-items-start
                        top-img-box
                        full-width
                        justify-content-between
                        px-2
                      "
                      data-toggle="modal"
                      v-bind:data-target="'#Attendee' + index"
                      data-tag="MeetingsAttendeeDetailsPopup"
                    >
                      <div
                        class="d-flex justify-content-start align-items-start"
                      >
                        <span
                          v-if="
                            attendee.Organizerprofilepic !== undefined &&
                            attendee.Organizerprofilepic.length > 0
                          "
                          class="attendee-img-area"
                        >
                          <img
                            v-bind:src="attendee.Organizerprofilepic"
                            v-bind:alt="attendee.OrganizerFname"
                          />
                        </span>
                        <span v-else class="attendee-img-area initial">{{
                          attendee.OrganizerAttendeesInitials
                        }}</span>

                        <div class="grey-bg-texthld attendee ml-2">
                          <h4 class="mt-0">{{ attendee.Organizername }}</h4>
                          <p
                            class="mb-0"
                            v-if="attendee.OrganizerTitle"
                            style="
                              width: 130px;
                              white-space: nowrap;
                              overflow-x: hidden;
                              text-overflow: ellipsis;
                            "
                          >
                            {{ attendee.OrganizerTitle }}
                          </p>
                          <p
                            class="mb-0"
                            v-if="attendee.OrganizerCompany"
                            style="
                              width: 130px;
                              white-space: nowrap;
                              overflow-x: hidden;
                              text-overflow: ellipsis;
                            "
                          >
                            {{ attendee.OrganizerCompany }}
                          </p>
                        </div>
                      </div>
                      <div class="session-status pt-0 mr-0">
                        <p style="white-space: nowrap !important">
                          <span
                            class="finish-session"
                            :style="
                              attendee.MeetingCurrentStatus === 'Live'
                                ? 'background-color:#00a982;'
                                : attendee.MeetingCurrentStatus === 'Upcoming'
                                ? 'background-color:#FFC300;'
                                : ''
                            "
                          ></span>
                          {{ attendee.MeetingCurrentStatus == "Meeting Ended" ? "Ended" : attendee.MeetingCurrentStatus }}
                        </p>
                      </div>
                    </div>

                    <div
                      v-if="attendee.SenderId == uid"
                      class="
                        d-flex
                        align-items-start
                        top-img-box
                        full-width
                        justify-content-between
                        px-2
                      "
                      data-toggle="modal"
                      v-bind:data-target="'#Attendee' + index"
                      data-tag="MeetingsAttendeeDetailsPopup"
                    >
                      <div
                        class="d-flex justify-content-start align-items-center"
                      >
                        <span
                          v-if="
                            attendee.Image !== undefined &&
                            attendee.Image.length > 0
                          "
                          class="attendee-img-area"
                        >
                          <img
                            v-bind:src="attendee.Image"
                            v-bind:alt="attendee.Name"
                          />
                        </span>
                        <span v-else class="attendee-img-area initial">{{
                          attendee.AttendeeInitials
                        }}</span>

                        <div class="grey-bg-texthld attendee ml-2">
                          <h4 class="mt-0">{{ attendee.Name }}</h4>
                          <p
                            class="mb-0"
                            v-if="attendee.Title"
                            style="
                              width: 130px;
                              white-space: nowrap;
                              overflow-x: hidden;
                              text-overflow: ellipsis;
                            "
                          >
                            {{ attendee.Title }}
                          </p>
                          <p
                            class="mb-0"
                            v-if="attendee.Company"
                            style="
                              width: 130px;
                              white-space: nowrap;
                              overflow-x: hidden;
                              text-overflow: ellipsis;
                            "
                          >
                            {{ attendee.Company }}
                          </p>
                        </div>
                      </div>
                      <div class="session-status pt-0 mr-0">
                        <p style="white-space: nowrap !important">
                          <span
                            class="finish-session"
                            :style="
                              attendee.MeetingCurrentStatus === 'Live'
                                ? 'background-color:#65cd3c;'
                                : attendee.MeetingCurrentStatus === 'Upcoming'
                                ? 'background-color:#FFC300;'
                                : ''
                            "
                          ></span>
                          {{ attendee.MeetingCurrentStatus }}
                        </p>
                      </div>
                    </div>

                    <div class="status redsn-evnts-col">
                      <article style="margin-left: 0px">
                        <ul class="p-0">
                          <li>
                            <h5 class="ico-calender-sm">
                              {{ attendee.StartDate }}
                            </h5>
                          </li>
                          <li>
                            <p class="ico-pin-sm">{{ attendee.StartTime }}</p>
                          </li>
                        </ul>
                      </article>
                    </div>
                    <div class="status redsn-evnts-col" style="display: block">
                      <div class="button-area text-right">
                        <button
                          :disabled="
                            currentMeetingId == attendee.MeetingId ||
                            attendee.MeetingCurrentStatus !== 'Live'
                          "
                          v-on:click="
                            StartMeeting(attendee.MeetingId);
                            return false;
                          "
                          :class="
                            attendee.MeetingCurrentStatus === 'Live' &&
                            currentMeetingId != attendee.MeetingId
                              ? 'btn-rounded j-meeting-btn'
                              : 'btn-rounded j-meeting-btn disable-slot'
                          "
                          data-tag="joinMeeting"
                        >
                          {{ $t("livestage.proceed") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import moment from "moment";
import moment from "moment-timezone";
import db from "../components/firebaseInit";
import router from "../router";
//import TopMenu from "@/components/TopMenu.vue";
//import RequestMeeting from "@/components/RequestMeeting.vue";
//import AttendeeDetails from "@/components/AttendeeDetails.vue";
import axios from "axios";
import APIs from "@/components/APIInit";
import analytics from "@/components/Analytics";
import common from "@/common";
import jQuery from "jquery";
let $ = jQuery;
let obj = JSON.parse(window.localStorage.getItem("my-app"));
let self;
//let lastVisible = null;
//let hasMore = true;

let interval;

export default {
  props: [
    "uid",
    "rightPanel",
    "allowRequestMeeting",
    "currentMeetingId",
    "sessionTypeId",
  ],
  data() {
    return {
      confirmCount: 0,
      requestSentCount: 0,
      requestReceivedCount: 0,
      headerText: this.$t("mymeetings.mymeetings"),
      pageSize: 9,
      pageIndex: 0,
      totalRecords: 1,
      lastVisible: null,
      attendeeData: [],

      GlobalKeysData: {
        IsOpenInternalPlayer: 1,
        IsBroadcastInNewTab: 1,
        broadcastbaseURL:
          "https://he96zdju46.execute-api.us-east-1.amazonaws.com/PRD/",
        BroadcastID: "605f401455444442838e00cb859c037b",
        BroadcastCertificate: "8f472eef21f64cba97c105eab797522f",
        BroadcastSpeakerApiUrl:
          "https://onairapi.e2m.live/get-session-token-speaker",
        BroadcastAttendeeApiUrl:
          "https://onairapi.e2m.live/get-session-token-attendee",
        BroadcastStartURL: "https://onair2.e2m.live/video/live-broadcast.html",
        BroadcastViewURL: "https://onair2.e2m.live/video/live-audience.html",
        videoId: "605f401455444442838e00cb859c037b",
        BroadcastvalidityHours: "72",
        ChannelPrefix: "OAUAT",
        OnDemandTypeID: 1,
        LiveStreamTypeID: 2,
        LivePanelTypeID: 3,
        RoundTableTypeID: 4,
        videoParamsEncryptURL: "https://awsapi.e2m.live/encrypt-call-params",
        Showall: false,
      },
      EmailURL: "https://awsapi.e2m.live/send-email",

      FCMURL: "https://fcm.googleapis.com/fcm/send",
      APIs: APIs,
      zoomErrorMsg:
        "An error has occurred with this Zoom live panel session. Please try again in sometime.",
      firstName: "",
      lastName: "",
      fullName: "",
    };
  },
  components: {
    //TopMenu,
    // AttendeeDetails,
  },
  computed: {
    Userlists() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return {
        userId: obj.user[0].id,
        userName: obj.user[0].name,
        userImage: obj.user[0].profilepic,
        userEmail: obj.user[0].Email,
        userPhone: obj.user[0].phone,
        userTitle: obj.user[0].title,
        userCompmany: obj.user[0].company,
      };
    },
  },
  created() {
    self = this;
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    if (obj && obj.user && obj.user.length > 0) {
      self.firstName = obj.user[0].fname;
      self.lastName = obj.user[0].lname;
      self.fullName = obj.user[0].name;
    }
  },
  methods: {
    goToBookAppointment() {
      this.$emit("goToBookAppointment");
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format();
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    toggleShowAll: function () {
      if ($("#customSwitch1").is(":checked")) {
        // self.attendeeData = self.attendeeData.filter(e => e.MeetingCurrentStatus !="Meeting Ended");
        $(".dvEnded").show();
      } else {
        //  return false;
        $(".dvEnded").hide();
      }
      //
    },
    navigate() {
      router.push({
        name: "AttendeeList",
        query: { filter: true, search: true },
      });
    },

    getCalendarDateTime: function (s, option) {
      var dt = new Date(s * 1000);

      var day = dt.getDate();
      var month = dt.getMonth() + 1;
      var year = dt.getFullYear();
      if (month < 10) {
        month = "0" + month.toString();
      }
      if (day < 10) {
        day = "0" + day.toString();
      }
      var hours = dt.getHours();
      if (hours < 10) {
        hours = "0" + hours.toString();
      }
      var minutes = dt.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes.toString();
      }
      var seconds = dt.getSeconds();
      if (seconds < 10) {
        seconds = "0" + seconds.toString();
      }

      var formattedValue = "";
      if (option == "google") {
        formattedValue =
          year.toString() +
          month.toString() +
          day.toString() +
          "T" +
          hours.toString() +
          minutes.toString() +
          seconds.toString();
      } else if (option == "outlook") {
        formattedValue =
          year.toString() +
          "%2F" +
          month.toString() +
          "%2F" +
          day.toString() +
          "+";

        if (hours < 10) {
          formattedValue += hours.toString() + "%3A";
        } else {
          if (hours <= 12) {
            formattedValue += hours.toString() + "%3A";
          } else {
            formattedValue += (hours - 12).toString() + "%3A";
          }
        }

        if (minutes < 10) {
          formattedValue += minutes.toString() + "+";
        } else {
          formattedValue += minutes.toString() + "+";
        }

        if (hours < 12) {
          formattedValue += "AM";
        } else {
          formattedValue += "PM";
        }
      }
      return formattedValue;
    },

    BookMeetingSlots(MeetingDateTime, OrganizerId) {
      //

      // var availableSlot = [];
      var dtStartDateTime = new Date(MeetingDateTime.seconds * 1000);
      var dtCurrent = moment(dtStartDateTime).format("MMMDD");
      var dttime = moment(dtStartDateTime).format("hh:mm A");
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var AvailableMeetingSlots = "AvailableMeetingSlots";
      var attendeeId = obj.user[0].id;

      var MdocRef = db
        .collection(obj.eventcollectionname)
        .doc("AttendeeList")
        .collection("Attendees")
        .doc(attendeeId)
        .collection(AvailableMeetingSlots)
        .where("StartDate", "==", moment(dtCurrent, moment.tz.guess()))
        .where("StartDatetime", "==", moment(dttime, moment.tz.guess()));

      MdocRef.get().then((querySnapshot) => {
        querySnapshot.forEach(function (doc) {
          doc.ref.delete();
        });
      });

      var OdocRef = db
        .collection(obj.eventcollectionname)
        .doc("AttendeeList")
        .collection("Attendees")
        .doc(OrganizerId)
        .collection(AvailableMeetingSlots)
        .where("StartDate", "==", dtCurrent)
        .where("StartDatetime", "==", dttime);

      OdocRef.get().then((querySnapshot) => {
        querySnapshot.forEach(function (doc) {
          doc.ref.delete();
        });
      });
    },
    getMeetingCurrentStatus: function (StartDateTime, EndDateTime) {
      var dtStartDateTime = StartDateTime;
      var dtEndDateTime = EndDateTime;

      var MeetingCurrentStatus = "";
      var dtcurrentDate = moment(new Date(), "UTC")
        .tz(moment.tz.guess())
        .format("YYYY-MM-DDTHH:mm:ss[Z]");

      if (dtStartDateTime > dtcurrentDate) {
        MeetingCurrentStatus = "Upcoming";
      }
      if (dtStartDateTime < dtcurrentDate && dtEndDateTime < dtcurrentDate) {
        MeetingCurrentStatus = "Meeting Ended";
      }
      if (dtStartDateTime < dtcurrentDate && dtEndDateTime >= dtcurrentDate) {
        MeetingCurrentStatus = "Live";
      }
      return MeetingCurrentStatus;
    },

    MeetingUpdate: function (
      MeetingId,
      Name, // AttendeeName
      Email, //AttendeeEmail
      Title, //AttendeeTitle
      Company, //AttendeeCompany
      Organizername,
      OrganizerEmail,
      OrganizerTitle,
      OrganizerCompany,
      Message,
      StartDateTime, //MeetingStartDateTime
      MeetingStatus, //Status-Request Sent, Request Received, Accepted
      attendeeId,
      attendeeImage,
      OrganizerId,
      OrganizerImage
    ) {
      var docRef = db
        .collection(obj.eventcollectionname)
        .doc("MeetingList")
        .collection("Meetings")
        .doc(MeetingId);
      docRef
        .get()
        .then(function (doc) {
          if (doc.exists) {
            StartDateTime = moment(doc.data().StartDateTime, "hh:mm A");
            self.TimezoneUpdate(MeetingId);
            db.collection(obj.eventcollectionname)
              .doc("MeetingList")
              .collection("Meetings")
              .doc(MeetingId)
              .update({
                Status: MeetingStatus,
                LastModifiedDate: new Date(),
              })
              .then(function () {
                //
                if (MeetingStatus === "Accepted") {
                  //
                  //self.BookMeetingSlots(StartDateTime, OrganizerId);

                  //alert("You have accepted this meeting");

                  var objEventName;
                  if (obj.eventname !== undefined) {
                    objEventName = obj.eventname;
                  } else {
                    objEventName = "";
                  }

                  //StartDateTime = moment(doc.data().StartDateTime, "hh:mm A");

                  //**** Start EMAIL Acceptance Mail To Meeting Receiver

                  var htmlmailbody3 = self.AcceptedMeetingEmailHtml(
                    Organizername,
                    Name,
                    OrganizerEmail,
                    OrganizerTitle,
                    OrganizerCompany,
                    StartDateTime,
                    Message
                  );

                  var ToEmail = Email;
                  if (location.origin.toLowerCase().indexOf("localhost") >= 0) {
                    ToEmail = "vishalakshi.murthy@webspiders.com";
                  }

                  var requestData3 = {
                    from: objEventName + "<noreply@mail.e2m.live>",
                    to: {
                      name: Name,
                      email: ToEmail,
                    },
                    // subject: Organizername + " have accepted this meeting",
                    subject: "You have accepted this meeting",
                    html: htmlmailbody3,
                  };
                  self.SentMeetingMail(requestData3);

                  //**** End EMAIL Acceptance Mail To Meeting Receiver

                  //**** Start EMAIL Acceptance Mail To Meeting Sender

                  var htmlmailbody4 = self.AcceptedMeetingEmailHtml(
                    Name,
                    Organizername,
                    Email,
                    Title,
                    Company,
                    StartDateTime,
                    Message
                  );

                  ToEmail = OrganizerEmail;
                  if (location.origin.toLowerCase().indexOf("localhost") >= 0) {
                    ToEmail = "vishalakshi.murthy@webspiders.com";
                  }

                  var requestData4 = {
                    from: objEventName + "<noreply@mail.e2m.live>",
                    to: {
                      name: Organizername,
                      email: ToEmail,
                    },
                    subject: Name + " has accepted this meeting",
                    html: htmlmailbody4,
                  };

                  self.SentMeetingMail(requestData4);

                  console.log(OrganizerImage);

                  self.SentMeetingNotification(
                    "accepted",
                    obj.user[0].name,
                    attendeeImage != "" ? attendeeImage : "",
                    OrganizerId
                  );

                  //router.push({name:"MyMeetings"});
                  //self.displayAttendees();

                  //**** End EMAIL Acceptance Mail To Meeting Sender
                }

                // $(".modal-dialog.xl").addClass("success");
              })
              .catch(function (error) {
                console.error("Error updating Meeting: ", error);
              });
          }
        })
        .catch(function (error) {
          console.log("Error saving Meeting:", error);
        });
      //this.displayAttendees();
      self.getMeetingList();
    },
    setFirebaseAppsettings: function () {
      //
      var docRefGeneralSettings = db
        .collection("OA_UAT")
        .doc("GeneralSettings");
      docRefGeneralSettings.get().then(function (doc) {
        if (doc.exists) {
          self.EmailURL = doc.data().EmailURL;
        }
      });

      //var obj = JSON.parse(window.localStorage.getItem("my-app"));

      var docRef = db.collection("OA_UAT").doc("OnAirAppSettings");

      docRef.get().then(function (doc) {
        if (doc.exists) {
          self.GlobalKeysData.BroadcastID = doc.data().AppIDRTC;
          self.GlobalKeysData.BroadcastCertificate = doc.data().CertificateRTC;
          self.GlobalKeysData.BroadcastSpeakerApiUrl =
            doc.data().SpeakerTokenURL;
          self.GlobalKeysData.BroadcastAttendeeApiUrl =
            doc.data().AttendeeTokenURL;
          self.GlobalKeysData.BroadcastStartURL = doc.data().BroadcastBaseURL;
          self.GlobalKeysData.BroadcastViewURL = doc.data().AudienceBaseURL;
          self.GlobalKeysData.BroadcastvalidityHours =
            doc.data().TokenValidityHours;
          self.GlobalKeysData.ChannelPrefix = doc.data().ChannelPrefix;
          self.GlobalKeysData.videoParamsEncryptURL = doc.data().EncryptionURL;
        }
      });
    },
    MeetingCancelled: function (
      MeetingId,
      Name, // AttendeeName
      Email, //AttendeeEmail
      Title, //AttendeeTitle
      Company, //AttendeeCompanys
      Organizername,
      OrganizerEmail,
      OrganizerTitle,
      OrganizerCompany,
      Message,
      StartDateTime, //MeetingStartDateTime
      MeetingStatus, //Status-Request Sent, Request Received, Accepted
      attendeeId,
      attendeeImage,
      OrganizerId,
      OrganizerImage
    ) {
      if (confirm("Are you sure you want to cancel the meetinng")) {
        var docRef = db
          .collection(obj.eventcollectionname)
          .doc("MeetingList")
          .collection("Meetings")
          .doc(MeetingId);
        docRef
          .get()
          .then(function (doc) {
            if (doc.exists) {
              self.TimezoneUpdate(MeetingId);
              db.collection(obj.eventcollectionname)
                .doc("MeetingList")
                .collection("Meetings")
                .doc(MeetingId)
                .update({
                  Status: MeetingStatus,
                  LastModifiedDate: new Date(),
                })
                .then(function () {
                  //
                  var stTime = moment(
                    doc.data().StartDateTime,
                    "h:mm A"
                  ).format("hh:mm A");
                  var edTime = moment(doc.data().EndDateTime, "h:mm A").format(
                    "hh:mm A"
                  );

                  var AvailableMeetingSlotsId =
                    moment(StartDateTime).format("MMMDD") +
                    "_" +
                    stTime +
                    "_" +
                    edTime;
                  var MeetingTime = AvailableMeetingSlotsId.split("_");

                  var MdocRef1 = db
                    .collection(obj.eventcollectionname)
                    .doc("AttendeeList")
                    .collection("Attendees")
                    .doc(attendeeId)
                    .collection("AvailableMeetingSlots")
                    .doc(AvailableMeetingSlotsId);

                  MdocRef1.get()
                    .then(function (doc) {
                      if (!doc.exists) {
                        var docObj = new Object();
                        docObj.AvailableMeetingSlotsId =
                          AvailableMeetingSlotsId;
                        docObj.StartDate = MeetingTime[0];
                        docObj.StartDatetime = MeetingTime[1];
                        docObj.EndDateTime = MeetingTime[2];

                        MdocRef1.set(docObj)
                          .then(function () {
                            //console.log("AvailableMeetingSlots Created ");
                          })
                          .catch(function (error) {
                            console.error(
                              "Error AvailableMeetingSlots: ",
                              error
                            );
                          });
                      }
                    })
                    .catch(function (error) {
                      console.error(
                        "Error creating AvailableMeetingSlots: ",
                        error
                      );
                    });

                  var MdocRef2 = db
                    .collection(obj.eventcollectionname)
                    .doc("AttendeeList")
                    .collection("Attendees")
                    .doc(OrganizerId)
                    .collection("AvailableMeetingSlots")
                    .doc(AvailableMeetingSlotsId);

                  MdocRef2.get()
                    .then(function (doc) {
                      if (!doc.exists) {
                        var docObj = new Object();
                        docObj.AvailableMeetingSlotsId =
                          AvailableMeetingSlotsId;
                        docObj.StartDate = MeetingTime[0];
                        docObj.StartDatetime = MeetingTime[1];
                        docObj.EndDateTime = MeetingTime[2];

                        MdocRef2.set(docObj)
                          .then(function () {
                            //console.log("AvailableMeetingSlots Created ");
                          })
                          .catch(function (error) {
                            console.error(
                              "Error AvailableMeetingSlots: ",
                              error
                            );
                          });
                      }
                    })
                    .catch(function (error) {
                      console.error(
                        "Error creating AvailableMeetingSlots: ",
                        error
                      );
                    });

                  alert("The meeting has been cancelled.");

                  var objEventName;
                  if (obj.eventname !== undefined) {
                    objEventName = obj.eventname;
                  } else {
                    objEventName = "";
                  }

                  StartDateTime = moment(StartDateTime, "hh:mm A");

                  //**** Start cancelled Mail To Meeting Receiver
                  var htmlmailbody1 = self.CancelledMeetingEmailHtml(
                    Name,
                    Organizername,
                    Email,
                    Title,
                    Company,
                    StartDateTime,
                    Message
                  );

                  var ToEmail = OrganizerEmail;

                  if (location.origin.toLowerCase().indexOf("localhost") >= 0) {
                    ToEmail = "vishalakshi.murthy@webspiders.com";
                  }

                  var requestData1 = {
                    from: objEventName + "<noreply@mail.e2m.live>",
                    to: {
                      name: obj.eventname,
                      email: ToEmail,
                    },
                    subject: "Alert! Meeting Request Cancelled",
                    html: htmlmailbody1,
                  };

                  self.SentMeetingMail(requestData1);

                  //**** End cancelled Mail To Meeting Receiver

                  //**** Start accepted Mail To Meeting Sender

                  console.log(OrganizerImage);
                  var htmlmailbody2 = self.CancelledMeetingEmailHtml(
                    Organizername,
                    Name,
                    OrganizerEmail,
                    OrganizerTitle,
                    OrganizerCompany,
                    StartDateTime,
                    Message
                  );

                  ToEmail = Email;
                  if (location.origin.toLowerCase().indexOf("localhost") >= 0) {
                    ToEmail = "vishalakshi.murthy@webspiders.com";
                  }

                  var requestData2 = {
                    from: objEventName + "<noreply@mail.e2m.live>",
                    to: {
                      name: Name,
                      email: ToEmail,
                    },
                    // subject: Organizername + " has cancelled this meeting",
                    subject: "Alert! Meeting Request Cancelled",
                    html: htmlmailbody2,
                  };

                  self.SentMeetingMail(requestData2);

                  self.SentMeetingNotification(
                    "cancelled",
                    obj.user[0].name,
                    attendeeImage != "" ? attendeeImage : "",
                    OrganizerId
                  );
                  //self.displayAttendees();
                  self.getMeetingList();
                  //**** End accepted Mail To Meeting Sender
                })
                .catch(function (error) {
                  console.error("Error updating Meeting: ", error);
                });
            }
          })
          .catch(function (error) {
            console.log("Error saving Meeting:", error);
          });
        //this.displayAttendees();
      }
    },
    displayAttendees() {
      self.attendeeData = [];

      //
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      // var CurrentUserId = obj.user[0].id;
      self.pageIndex++;
      var listRef;

      listRef = db
        .collection(obj.eventcollectionname)
        .doc("MeetingList")
        .collection("Meetings");

      //
      listRef
        .orderBy("StartDateTime", "desc")
        .onSnapshot((querySnapshot) => {
          self.attendeeData = [];
          var ConfirmCtr = 0;
          var ReqSentCtr = 0;
          var ReqRecCtr = 0;
          $("#spConfirm").text("");
          $("#spReqSent").text("");
          $("#spReqRec").text("");
          if (querySnapshot.docs.length > 0) {
            //
            //  if (hasMore) {
            $("#divnomeetings").hide();
            //lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
            //
            querySnapshot.forEach((doc) => {
              var obj = JSON.parse(window.localStorage.getItem("my-app"));
              if (obj.MeetingSettings[0].ByTimezone === true) {
                self.attendeeData.push({
                  MeetingId: doc.id,
                  attendeeId: doc.data().AttendeeId,
                  MeetingType: doc.data().MeetingType,
                  Message: doc.data().Message,
                  Name: doc.data().AttendeeName,
                  Company: doc.data().Company,
                  Title: doc.data().Title,
                  StartDate: moment(
                    self.GetTimeByZone(
                      doc.data().StartDateTime.toDate(),
                      moment.tz.guess()
                    )
                  ).format("ddd D MMM"),
                  StartTime: moment(
                    self.GetTimeByZone(
                      doc.data().StartDateTime.toDate(),
                      moment.tz.guess()
                    )
                  ).format("hh:mm A"),
                  StartDateTime: moment(
                    self.GetTimeByZone(
                      doc.data().StartDateTime.toDate(),
                      moment.tz.guess()
                    )
                  ),
                  EndDateTime: moment(
                    self.GetTimeByZone(
                      doc.data().StartDateTime.toDate(),
                      moment.tz.guess()
                    )
                  ),
                  EndTime: moment(
                    self.GetTimeByZone(
                      doc.data().StartDateTime.toDate(),
                      moment.tz.guess()
                    )
                  ),
                  Email: doc.data().AttendeeEmail,
                  Image: doc.data().AttendeeImage,
                  Phone: doc.data().AttendeePone,
                  Status: doc.data().Status,
                  ReceiverId: doc.data().ReceiverId,
                  SenderId: doc.data().SenderId,

                  OrganizerId: doc.data().OrganizerAttendees.id,
                  OrganizerEmail: doc.data().OrganizerAttendees.Email,
                  OrganizerFname: doc.data().OrganizerAttendees.fname,
                  OrganizerLname: doc.data().OrganizerAttendees.lname,
                  Organizername: doc.data().OrganizerAttendees.name,
                  Organizerprofilepic: doc.data().OrganizerAttendees.profilepic,
                  OrganizerCompany: doc.data().OrganizerAttendees.company,
                  OrganizerTitle: doc.data().OrganizerAttendees.title,

                  AttendeeInitials: self.getInitials(
                    doc.data().FirstName + " " + doc.data().LastName
                  ),
                  OrganizerAttendeesInitials: self.getInitials(
                    doc.data().OrganizerAttendees.fname +
                      " " +
                      doc.data().OrganizerAttendees.lname
                  ),
                  MeetingCurrentStatus: self.getMeetingCurrentStatus(
                    doc.data().StartDateTime,
                    doc.data().EndDateTime
                  ),
                  ShowAll: $("#customSwitch1").is(":checked"),
                });
              } else {
                self.attendeeData.push({
                  MeetingId: doc.id,
                  attendeeId: doc.data().AttendeeId,
                  MeetingType: doc.data().MeetingType,
                  Message: doc.data().Message,
                  Name: doc.data().AttendeeName,
                  Company: doc.data().Company,
                  Title: doc.data().Title,
                  StartDate: moment(doc.data().StartDateTime.toDate()).format(
                    "ddd D MMM"
                  ),
                  StartTime: moment(doc.data().StartDateTime.toDate()).format(
                    "hh:mm A"
                  ),
                  StartDateTime: doc.data().StartDateTime,
                  EndDateTime: doc.data().EndDateTime,
                  EndTime: doc.data().EndDateTime,
                  Email: doc.data().AttendeeEmail,
                  Image: doc.data().AttendeeImage,
                  Phone: doc.data().AttendeePone,
                  Status: doc.data().Status,
                  ReceiverId: doc.data().ReceiverId,
                  SenderId: doc.data().SenderId,

                  OrganizerId: doc.data().OrganizerAttendees.id,
                  OrganizerEmail: doc.data().OrganizerAttendees.Email,
                  OrganizerFname: doc.data().OrganizerAttendees.fname,
                  OrganizerLname: doc.data().OrganizerAttendees.lname,
                  Organizername: doc.data().OrganizerAttendees.name,
                  Organizerprofilepic: doc.data().OrganizerAttendees.profilepic,
                  OrganizerCompany: doc.data().OrganizerAttendees.company,
                  OrganizerTitle: doc.data().OrganizerAttendees.title,

                  AttendeeInitials: doc.data().Initials,
                  OrganizerAttendeesInitials: self.getInitials(
                    doc.data().OrganizerAttendees.fname +
                      " " +
                      doc.data().OrganizerAttendees.lname
                  ),
                  MeetingCurrentStatus: self.getMeetingCurrentStatus(
                    doc.data().StartDateTime,
                    doc.data().EndDateTime
                  ),
                  ShowAll: $("#customSwitch1").is(":checked"),
                });
              }

              if (
                (doc.data().ReceiverId == obj.user[0].id ||
                  doc.data().SenderId == obj.user[0].id) &&
                doc.data().Status == "Accepted"
              ) {
                ConfirmCtr++;
              }
              if (doc.data().SenderId == obj.user[0].id) {
                ReqSentCtr++;
              }
              if (doc.data().ReceiverId == obj.user[0].id) {
                ReqRecCtr++;
              }
              $("#spConfirm").text("(" + ConfirmCtr + ")");
              $("#spReqSent").text("(" + ReqSentCtr + ")");
              $("#spReqRec").text("(" + ReqRecCtr + ")");
            });
          } else {
            $("#divnomeetings").show();
          }
        })
        .catch((error) => {
          console.log(error);
          // console.log("Error getting documents: ", error);
        });
    },
    attendeeLargeImg: function (img) {
      $("#imgModal").trigger("click");
      $("#attendeeImgSrc").attr("src", img);
    },
    getInitials: function (str) {
      var matches = str.match(/\b(\w)/g); // ['J','S','O','N']
      var acronym = matches.join(""); // JSON
      return acronym;
      //console.log(acronym);
    },
    scroll: function () {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight + 1 >=
          document.documentElement.offsetHeight;
        if (bottomOfWindow) {
          //self.displayAttendees();
          self.getMeetingList();
          //this.AddAnalitics(event, "scroll");
        }
      };
    },
    exitmenu: function () {
      //  $(".tab-content-one .tab-pane").removeClass("active");
      $(".nav-link.tab-link").removeClass("active");
    },
    StartBroadcast: function (meetingId, streamingClient) {
      // var obj3 = JSON.parse(window.localStorage.getItem("my-app"));
      // if (
      //   screen.width < 767 &&
      //   obj3.AgoraPlayerBrowserSupportInMobile == false
      // ) {
      //   router.push("/screeninfo");
      // } else if (
      //   screen.width >= 768 &&
      //   screen.width <= 1024 &&
      //   obj3.AgoraPlayerBrowserSupportInIPad == false
      // ) {
      //   router.push("/screeninfo");
      // } else {
        if (streamingClient) {
          streamingClient = streamingClient.toLowerCase().trim();
        }
        if (!streamingClient || streamingClient == "web") {
          var channel = meetingId + "_o2o";
          window.open("/livestage/" + channel, "_blank");
        } else if (streamingClient == "zoom") {
          var meetings = self.attendeeData.filter(function (item) {
            return item.MeetingId == meetingId;
          });
          var meeting;
          if (meetings.length > 0) {
            meeting = meetings[0];
          }
          if (
            meeting &&
            meeting.Host &&
            meeting.Host.length > 0 &&
            meeting.Zoom_Detail &&
            meeting.Zoom_Detail.id
          ) {
            if (self.uid == meeting.Host[0].AttendeeId) {
              var hlink =
                meeting.Zoom_Detail.start_url +
                "&uname=" +
                self.firstName.trim() +
                "%20" +
                self.lastName.trim();
              window.open(hlink, "_blank");
            } else {
              var link =
                meeting.Zoom_Detail.join_url +
                "&uname=" +
                self.firstName.trim() +
                "%20" +
                self.lastName.trim();
              window.open(link, "_blank");
            }
          } else {
            alert(self.zoomErrorMsg);
          }
        }
      // }
    },
    StartMeeting(meetingId) {
      self.$emit("startMeeting", meetingId);
    },
    SendVideoJoinedMail: function (
      ReceiverName,
      ReceiverEmail,
      Title,
      Company,
      usrid,
      chatToId,
      chatToImage
    ) {
      //**** Start EMAIL Video joined Mail To Meeting Receiver

      var obj = JSON.parse(window.localStorage.getItem("my-app"));

      var SenderName = obj.user[0].name;
      var SenderEmail = obj.user[0].Email;

      //if (location.origin.toLowerCase().indexOf("localhost") >= 0) {
      //ReceiverEmail = "vishalakshi.murthy@webspiders.com";
      //}

      var htmlVideojoin = self.GetVideoJoinEmailHtmlBody(
        SenderName,
        SenderEmail,
        ReceiverName,
        Title,
        Company
      );

      if (location.origin.toLowerCase().indexOf("localhost") >= 0) {
        ReceiverEmail = "vishalakshi.murthy@webspiders.com";
      }
      var objEventName;
      if (obj.eventname !== undefined) {
        objEventName = obj.eventname;
      } else {
        objEventName = "";
      }

      var requestData1 = {
        from: objEventName + "<noreply@mail.e2m.live>",
        to: {
          name: ReceiverName,
          email: ReceiverEmail,
        },
        subject: "Meeting alert! " + SenderName + " has started the meeting",
        html: htmlVideojoin,
      };
      self.SentMeetingMail(requestData1);

      self.SentMeetingNotification(
        "joined",
        SenderName,
        chatToImage != "" ? chatToImage : "",
        chatToId
      );
      //**** End EMAIL Video joined Mail To Meeting Receiver
    },

    // Video URL Encryption
    getEncryptedVideoURLParams: function (
      videoParamsEncryptURL,
      VideoBaseURL,
      TokenValidityHours,
      ChannelID,
      UserID,
      SessionTitle,
      clientId,
      callBackFunction
    ) {
      // alert("getEncryptedVideoURLParams");
      console.log(
        "qString - channelName - " +
          ChannelID.toString() +
          " userId- " +
          parseInt(UserID) +
          " validityHours - " +
          parseInt(TokenValidityHours) +
          " isScreen - 0" +
          " sname - " +
          SessionTitle.toString() +
          " clientID - " +
          clientId
      );

      var qString = {
        channelName: ChannelID.toString(),
        userId: parseInt(UserID),
        validityHours: parseInt(TokenValidityHours),
        isScreen: 0,
        sname: SessionTitle.toString(),
        clientId: clientId,
      };

      var encParam = "";
      var videoURL = VideoBaseURL;

      $.ajax({
        url: videoParamsEncryptURL,
        headers: {
          "Content-Type": "application/json",
        },
        beforeSend: function () {
          self.showLoader();
        },
        type: "POST",
        dataType: "json",
        data: JSON.stringify(qString),
        success: function (data) {
          if (typeof data != "undefined") {
            self.hideLoader();
            let lStatusCode = 0;
            lStatusCode = data.status;
            if (lStatusCode == 0) {
              encParam = data.result;
              videoURL = videoURL + "?vt=" + encParam;
              callBackFunction(videoURL, UserID);
              console.log("Get Encrypt URL API Call Success");
            } else {
              self.hideLoader();
              alert("Error initiating video call. Please retry. ");
              //console.log("Encrypted URL not found in API Call");
              //alert("URL decode has been failed before starting OnAir");
            }
          } else {
            self.hideLoader();
            alert("Error initiating video call. Please retry. ");
            //console.log("Encrypted URL not found in API Call");
            //alert("URL decode has been failed before starting OnAir");
          }
        },
        error: function () {
          self.hideLoader();
          alert("Error initiating video call. Please retry. ");
          //console.log("Error in Get Encrypt URL API Call");
          //alert("URL decode has been failed before starting OnAir");
        },
      });
    },
    showLoader: function () {
      if ($("#divLoading") != null) {
        $("#divLoading").show();
      }
    },
    hideLoader: function () {
      //if (timerLoader != null) {
      clearTimeout(this.timerLoader);
      // alert("outside");
      if ($("#divLoading") != null) {
        //alert("inside");
        $("#divLoading").hide();
      }
      //}
    },
    readCookieForVideo: function (name) {
      var nameEQ = encodeURIComponent(name) + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
          return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
      return null;
    },
    AcceptedMeetingEmailHtml: function (
      SenderName,
      ReceiverName,
      Email,
      Title,
      Company,
      dStartDateTime, //MeetingStartDateTime
      Message
    ) {
      var Meetingurl = "https://" + location.host.toLowerCase() + "/mymeetings";
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var ClientName = obj.client[0].name;

      let htmlmailbody = "<html><body>";
      htmlmailbody += "<p> Hello " + ReceiverName + ", </p>";
      htmlmailbody += "<p>Meeting request is accepted</p>";
      htmlmailbody += "<table>";
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Meeting With: </td>";
      htmlmailbody += "<td>" + SenderName + "</td>";
      htmlmailbody += "</tr>";

      if (Title != "" && Title != "undefined") {
        htmlmailbody += "<tr>";
        htmlmailbody += "<td>Title: </td>";
        htmlmailbody += "<td>" + Title + "</td>";
        htmlmailbody += "</tr>";
      }

      if (Company != "" && Company != "undefined") {
        htmlmailbody += "<tr>";
        htmlmailbody += "<td>Company:</td>";
        htmlmailbody += "<td>" + Company + "</td>";
        htmlmailbody += "</tr>";
      }
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Email:</td>";
      htmlmailbody += "<td>" + Email + "</td>";
      htmlmailbody += "</tr>";
      // htmlmailbody += "<tr>";
      // htmlmailbody += "<td>When</td>";
      //
      // htmlmailbody += "<td>" + moment(dStartDateTime,"DD-MM-YYYY HH:mm A").format(
      //     "dddd, MMMM Do YYYY, h:mm a"
      //   ); + " ("+ obj.tzone +" )</td>";
      // htmlmailbody += "</tr>";
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Message:</td>";
      htmlmailbody += "<td>" + Message + "</td>";
      htmlmailbody += "</tr>";
      htmlmailbody += "</table> ";
      htmlmailbody += "<br/>";
      htmlmailbody +=
        "<p>Visit <a href='" +
        Meetingurl +
        "'>" +
        Meetingurl +
        "</a> to check the status of all your meetings.</p>";
      htmlmailbody += "<br/>";
      htmlmailbody += "<p>Team " + ClientName + "</p>";
      htmlmailbody += "</body></ html>";
      return htmlmailbody;
    },
    CancelledMeetingEmailHtml: function (
      SenderName,
      ReceiverName,
      Email,
      Title,
      Company,
      dStartDateTime, //MeetingStartDateTime
      Message
    ) {
      var Meetingurl = "https://" + location.host.toLowerCase() + "/mymeetings";
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var ClientName = obj.client[0].name;

      let htmlmailbody = "<html><body>";
      htmlmailbody += "<p> Hello " + ReceiverName + ", </p>";
      htmlmailbody += "<p>Meeting request is cancelled</p>";
      htmlmailbody += "<table>";
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Meeting With: </td>";
      htmlmailbody += "<td>" + SenderName + "</td>";
      htmlmailbody += "</tr>";

      if (Title != "" && Title != "undefined") {
        htmlmailbody += "<tr>";

        htmlmailbody += "<td>Title: </td>";
        htmlmailbody += "<td>" + Title + "</td>";
        htmlmailbody += "</tr>";
      }

      if (Company != "" && Company != "undefined") {
        htmlmailbody += "<tr>";
        htmlmailbody += "<td>Company:</td>";
        htmlmailbody += "<td>" + Company + "</td>";
        htmlmailbody += "</tr>";
      }
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Email:</td>";
      htmlmailbody += "<td>" + Email + "</td>";
      htmlmailbody += "</tr>";
      htmlmailbody += "<tr>";
      // htmlmailbody += "<td>When</td>";
      //
      //  htmlmailbody += "<td>" + moment(dStartDateTime,"DD-MM-YYYY HH:mm A").format(
      //     "dddd, MMMM Do YYYY, h:mm a"
      //   ); + " ("+ obj.tzone +" )</td>";
      // htmlmailbody += "</tr>";
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Message:</td>";
      htmlmailbody += "<td>" + Message + "</td>";
      htmlmailbody += "</tr>";
      htmlmailbody += "</table> ";
      htmlmailbody += "<br/>";

      if (ReceiverName != obj.user[0].name) {
        htmlmailbody +=
          " Please note: You may request for another meeting at different date and time.";
        htmlmailbody += "<br/>";
      }

      htmlmailbody +=
        "<p>Visit <a href='" +
        Meetingurl +
        "'>" +
        Meetingurl +
        "</a> to check the status of all your meetings.</p>";
      htmlmailbody += "<br/>";
      htmlmailbody += "<p>Team " + ClientName + "</p>";
      htmlmailbody += "</body></ html>";
      return htmlmailbody;
    },
    GetVideoJoinEmailHtmlBody: function (
      SenderName,
      SenderEmail,
      ReceiverName,
      Title,
      Company
    ) {
      var Meetingurl = "https://" + location.host.toLowerCase() + "/mymeetings";
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var ClientName = obj.client[0].name;

      let htmlmailbody = "<html><body>";
      htmlmailbody += "<p>Hello " + ReceiverName + ", </p>";
      htmlmailbody += "<p>" + SenderName + " has joined the meeting!</p>";
      htmlmailbody +=
        "Visit " +
        Meetingurl +
        ' and click on the "Join Meeting" button under Confirmed tab now!';
      htmlmailbody += "<table>";
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Meeting With: </td>";
      htmlmailbody += "<td>" + SenderName + "</td>";
      htmlmailbody += "</tr>";

      if (Title != "" && Title != "undefined") {
        htmlmailbody += "<tr>";
        htmlmailbody += "<td>Title: </td>";
        htmlmailbody += "<td>" + Title + "</td>";
        htmlmailbody += "</tr>";
      }

      if (Company != "" && Company != "undefined") {
        htmlmailbody += "<tr>";
        htmlmailbody += "<td>Company:</td>";
        htmlmailbody += "<td>" + Company + "</td>";
        htmlmailbody += "</tr>";
      }
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Email:</td>";
      htmlmailbody += "<td>" + SenderEmail + "</td>";
      htmlmailbody += "</tr>";
      htmlmailbody += "</table> ";
      htmlmailbody += "<br/>";
      htmlmailbody += "<p>Team " + ClientName + "</p>";
      htmlmailbody += "</body></ html>";
      return htmlmailbody;
    },
    SentMeetingMail: function (EMailObj) {
      console.log(JSON.stringify(EMailObj));

      $.ajax({
        url: self.EmailURL,
        headers: {
          "Content-Type": "application/json",
        },
        type: "POST",
        dataType: "json",
        processData: false,
        data: JSON.stringify(EMailObj),
        beforeSend: function () {},
        success: function (data) {
          if (data) {
            console.log(JSON.stringify(data));
          } else {
            console.log("null");
          }
        },

        error: function () {
          console.log("Error in mail Sent");
        },
      });
    },
    SentMeetingNotification: function (
      type,
      SenderName,
      SenderProfilePictureURL,
      ReceiverId
    ) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));

      var objEventName;
      if (obj.eventname !== undefined) {
        objEventName = obj.eventname;
      } else {
        objEventName = "";
      }

      var Meetingurl = location.host.toLowerCase() + "/mymeetings";
      var vardeviceToken = "";
      var varFirebaseServerKey = "";
      var NotificationSettings = [];

      var docMSRef = db
        .collection(obj.eventcollectionname)
        .doc("MeetingList")
        .collection("Settings")
        .doc("MeetingSettings");

      docMSRef.get().then(function (doc) {
        if (doc.exists) {
          var MObj = new Object();
          MObj.NotificationMessage = doc.data().NotificationMessage;
          NotificationSettings.push(MObj.NotificationMessage);
          //

          var message;
          var messageName;
          var notifybefore;
          var NotifyTypeIndex;
          var PushNotificationIcon = "/images/success.png";

          if (type == "newrequest") {
            if (NotificationSettings.length >= 1) {
              message = NotificationSettings[0][1].Message.replace(
                "{{MeetingRequestor}}",
                SenderName
              );

              messageName = NotificationSettings[0][1].Name;
              NotifyTypeIndex = 1;
              notifybefore = 30;
              PushNotificationIcon = "/images/success.png";
            }
          }
          if (type == "joined") {
            if (NotificationSettings.length >= 1) {
              message = NotificationSettings[0][2].Message.replace(
                "{{MeetingJoinee}}",
                SenderName
              ).replace("{{MyMeetings}}", Meetingurl);

              messageName = NotificationSettings[0][2].Name;
              NotifyTypeIndex = 2;
              notifybefore = 30;
              PushNotificationIcon = "/images/started.png";
            }
          }

          if (type == "cancelled") {
            if (NotificationSettings.length >= 1) {
              message = NotificationSettings[0][3].Message.replace(
                "{{MeetingReceiver}}",
                SenderName
              );
              messageName = NotificationSettings[0][3].Name;
              NotifyTypeIndex = 3;
              notifybefore = 30;
              PushNotificationIcon = "/images/declined.png";
            }
          }

          if (type == "accepted") {
            if (NotificationSettings.length >= 1) {
              message = NotificationSettings[0][4].Message.replace(
                "{{MeetingReceiver}}",
                SenderName
              );

              messageName = NotificationSettings[0][4].Name;
              NotifyTypeIndex = 4;
              notifybefore = 30;
              PushNotificationIcon = "/images/success.png";
            }
          }

          var NotificationsId = ReceiverId + "_" + new Date().getTime();

          var MdocRef = db
            .collection(obj.eventcollectionname)
            .doc("AttendeeList")
            .collection("Attendees")
            .doc(ReceiverId)
            .collection("Notifications")
            .doc(NotificationsId);
          //
          MdocRef.get()
            .then(function (doc) {
              if (!doc.exists) {
                var docObj = new Object();
                docObj.Name = SenderName;
                docObj.Initials = self.getInitials(SenderName);
                docObj.ProfilePictureURL = SenderProfilePictureURL;
                docObj.Message = message;
                docObj.Title = messageName;
                docObj.NotifyTypeIndex = NotifyTypeIndex;
                docObj.Module = "Meeting";
                docObj.Time = new Date();
                docObj.ExpireInMinutes = notifybefore;
                docObj.isSeen = "0";
                docObj.CreatedDate = new Date();
                docObj.LastModifiedDate = new Date();

                MdocRef.set(docObj)
                  .then(function () {
                    console.log("Attendees Notifications Created ");

                    //**** Start web push
                    var docNRef = db
                      .collection(obj.eventcollectionname)
                      .doc("SubscribersList")
                      .collection("Subscriptions")
                      .doc(ReceiverId);

                    docNRef.get().then(function (doc) {
                      if (doc.exists) {
                        vardeviceToken = doc.data().DeviceToken;

                        db.collection("OA_UAT")
                          .doc("GeneralSettings")
                          .get()
                          .then(function (doc) {
                            if (doc.exists) {
                              varFirebaseServerKey =
                                doc.data().FirebaseServerKey;

                              console.log(varFirebaseServerKey);

                              $.ajax({
                                type: "POST",
                                url: self.FCMURL, //"https://fcm.googleapis.com/fcm/send",
                                headers: {
                                  Authorization: "key=" + varFirebaseServerKey,
                                  //"AAAAG8IFqjo:APA91bFOKr3FfPU-5AvL7MT3iKTVoibWIiCKGGRW03nXEmfqbyKfdgN_13R9sTV44JgXWsAN-tR4YGN-6UNcPn04otBHPoeC6ST3mf57aouf9BAjKlwv-X79cs4QTBEW7jbCbo1hqV4W",
                                },
                                contentType: "application/json",
                                dataType: "json",
                                data: JSON.stringify({
                                  to:
                                    // "eFubKrT2vBqLcaG9CYHltn:APA91bFUxnztqwgY-NJ5DytxdExZTkFNjFYgIjIWnTU2usuxP8HEmTTuj_cTdECdMxxUGVJtypEm_8Z1nP9LbnckV2CVoWzyKb1n-PysSEze_oen_4qXg2kBngliwJAHS3DUGVw7cJg4",
                                    vardeviceToken,
                                  notification: {
                                    title: objEventName + ": " + messageName,
                                    body: message,
                                    icon: PushNotificationIcon,
                                  },
                                }),
                                success: function (response) {
                                  console.log(
                                    "PushNotifications respone: ",
                                    response
                                  );
                                },
                                error: function (xhr, status, error) {
                                  console.log(xhr);
                                  console.log(status);
                                  console.log(
                                    "Error PushNotifications : ",
                                    error
                                  );
                                },
                              });
                            }
                          });
                      }
                    });
                    //**** End web push
                  })
                  .catch(function (error) {
                    console.error("Error AttendeesNotifications : ", error);
                  });
              }
            })
            .catch(function (error) {
              console.error("Error creating AttendeesNotifications: ", error);
            });
        }
      });
    },
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              this.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                this.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          this.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            this.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    onClickHandler(event) {
      // event.target is the clicked element object
      this.AddAnalitics(event, "click");
    },
    TimezoneUpdate: function (MeetingId) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var docRef = db
        .collection(obj.eventcollectionname)
        .doc("MeetingList")
        .collection("Meetings")
        .doc(MeetingId);
      docRef.get().then(function (doc) {
        if (doc.exists) {
          if (doc.data().ReciverTimeZone === "") {
            db.collection(obj.eventcollectionname)
              .doc("MeetingList")
              .collection("Meetings")
              .doc(MeetingId)
              .update({
                ReciverTimeZone: moment.tz.guess(),
              })
              .then(function () {});
          }
        }
      });
    },
    getMeetingList: function () {
      const obj = JSON.parse(window.localStorage["my-app"]);
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },
      };
      axios
        .post(
          self.APIs.MeetingAPIConfig.GetMeetingList,
          JSON.stringify(requestData),
          {
            headers: headers,
          }
        )
        .then((response) => {
          var res = response.data;
          self.attendeeData = [];
          var ConfirmCtr = 0;
          var ReqSentCtr = 0;
          var ReqRecCtr = 0;
          $("#spConfirm").text("");
          $("#spReqSent").text("");
          $("#spReqRec").text("");
          //console.log(res);
          var allArray = [
            ...res.result.Pending,
            ...res.result.Accepted,
            ...res.result.Canceled,
            ...res.result.Rejected,
            ...res.result.FYA,
          ];

          allArray = allArray.reduce(function (item, e1) {
            var matches = item.filter(function (e2) {
              return e1.MeetingId == e2.MeetingId;
            });
            if (matches.length == 0) {
              item.push(e1);
            }
            return item;
          }, []);

          // if (obj.MeetingSettings[0].ByTimezone === true) {
          //   self.bindMeetingListwithtimezone(allArray);
          // } else {
          //   self.bindMeetingListwithoutTimezone(allArray);
          // }
          //self.bindMeetingListwithoutTimezone(allArray);
          self.bindMeetingListwithtimezone(allArray);
          self.attendeeData = self.attendeeData.sort(function compare(a, b) {
            //parseInt(new Date(events[i].EventStartDateTime).getTime() / 1000)
            var dateA = parseInt(new Date(a.StartDateTime).getTime() / 1000);
            var dateB = parseInt(new Date(b.StartDateTime).getTime() / 1000);
            return dateA - dateB;
          });

          if (self.sessionTypeId == 6 && self.rightPanel) {
            var currentMeetingEndTime = 0;
            var nextMeetingId = "";
            //var nextMeetingStartTime;
            var currentTime = parseInt(new Date().getTime() / 1000);
            var flag = false;
            for (var j = 0; j < self.attendeeData.length; j++) {
              var meeting = self.attendeeData[j];
              if (self.currentMeetingId == meeting.MeetingId) {
                currentMeetingEndTime = parseInt(
                  new Date(meeting.EndDateTime).getTime() / 1000
                );
              } else if (currentMeetingEndTime > 0) {
                if (
                  (currentMeetingEndTime + 1 >
                    parseInt(
                      new Date(meeting.StartDateTime).getTime() / 1000
                    ) &&
                    currentTime + 10 <
                      parseInt(
                        new Date(meeting.EndDateTime).getTime() / 1000
                      )) ||
                  (currentTime + 1 >
                    parseInt(
                      new Date(meeting.StartDateTime).getTime() / 1000
                    ) &&
                    currentTime + 10 <
                      parseInt(new Date(meeting.EndDateTime).getTime() / 1000))
                ) {
                  nextMeetingId = meeting.MeetingId;
                  //alert(nextMeetingId);
                  this.$emit("setNextMeetingData", nextMeetingId, meeting);
                  flag = true;
                }
              }
            }
            if (!flag) {
              this.$emit("setNextMeetingData", "", null);
            }
          }

          for (var i = 0; i <= self.attendeeData.length - 1; i++) {
            if (
              (self.attendeeData[i].ReceiverId == obj.user[0].id ||
                self.attendeeData[i].SenderId == obj.user[0].id) &&
              self.attendeeData[i].Status == "Accepted"
            ) {
              ConfirmCtr++;
            }
            if (self.attendeeData[i].SenderId == obj.user[0].id) {
              ReqSentCtr++;
            }
            if (self.attendeeData[i].ReceiverId == obj.user[0].id) {
              ReqRecCtr++;
            }
          }
          self.confirmCount = ConfirmCtr;
          self.requestSentCount = ReqSentCtr;
          self.requestReceivedCount = ReqRecCtr;

          $("#spConfirm").text("(" + ConfirmCtr + ")");
          $("#spReqSent").text("(" + ReqSentCtr + ")");
          $("#spReqRec").text("(" + ReqRecCtr + ")");
          //console.log(self.attendeeData);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    acceptMeeting: function (meetingid, e) {
      $(e.target).html("...");
      const obj = JSON.parse(window.localStorage["my-app"]);
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },
        data: {
          MeetingId: meetingid,
        },
      };

      axios
        .post(self.APIs.MeetingAPIConfig.AcceptMeeting, requestData, {
          headers: headers,
        })
        .then((response) => {
          console.log(response);
          $(e.target).html(self.$t("mymeetings.joinmeeting"));

          //self.getMeetingList();
        })
        .catch((error) => {
          //$(e.target).html(self.$t("mymeetings.joinmeeting"));
          console.log(error);
        });
    },
    rejectMeeting: function (meetingid, e) {
      $(e.target).html("...");
      const obj = JSON.parse(window.localStorage["my-app"]);
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },
        data: {
          MeetingId: meetingid,
        },
      };
      axios
        .post(
          self.APIs.MeetingAPIConfig.RejectMeeting,
          JSON.stringify(requestData),
          {
            headers: headers,
          }
        )
        .then((response) => {
          console.log(response);
          //self.getMeetingList();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    cancelMeeting: function (meetingid, e) {
      $(e.target).html("...");
      const obj = JSON.parse(window.localStorage["my-app"]);
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },
        data: {
          MeetingId: meetingid,
        },
      };
      axios
        .post(
          self.APIs.MeetingAPIConfig.CancelMeeting,
          JSON.stringify(requestData),
          {
            headers: headers,
          }
        )
        .then((response) => {
          console.log(response);
          //$(e.target).html(self.$t("mymeetings.joinmeeting"));
        })
        .catch((error) => {
          console.log(error);
        });
    },
    bindMeetingListwithtimezone: function (meetingDoc) {
      let i;
      const obj = JSON.parse(window.localStorage["my-app"]);
      for (i = 0; i <= meetingDoc.length - 1; i++) {
        let meetingStatus = self.getMeetingCurrentStatus(
          moment(meetingDoc[i].Slots[0]).format("YYYY-MM-DDTHH:mm:ss[Z]"),
          moment(meetingDoc[i].Slots[0])
            .add(parseInt(obj.MeetingSettings[0].Duration), "minutes")
            .format("YYYY-MM-DDTHH:mm:ss[Z]")
        );
        if (
          (meetingStatus === "Live" ||
            meetingStatus === "Upcoming" ||
            meetingDoc[i].MeetingId == self.currentMeetingId) &&
          meetingDoc[i].Status == "Accepted"
        ) {
          self.attendeeData.push({
            MeetingId: meetingDoc[i].MeetingId,
            MeetingType: meetingDoc[i].MeetingType,
            StreamingClient: meetingDoc[i].StreamingClient
              ? meetingDoc[i].StreamingClient
              : "Web",
            Host: meetingDoc[i].Host ? meetingDoc[i].Host : [],
            Zoom_Detail: meetingDoc[i].Zoom_Detail
              ? meetingDoc[i].Zoom_Detail
              : null,
            Message: meetingDoc[i].Message,
            Name: meetingDoc[i].Invitee.Name,
            Company: meetingDoc[i].Invitee.Company,
            Title: meetingDoc[i].Invitee.Designation,
            StartDate: moment(meetingDoc[i].Slots[0]).format("ddd D MMM"),
            StartTime: moment(
              self.GetTimeByZone(meetingDoc[i].Slots[0], moment.tz.guess())
            ).format("hh:mm A"),
            StartDateTime: moment(
              self.GetTimeByZone(meetingDoc[i].Slots[0], moment.tz.guess())
            ),
            EndDateTime: moment(
              self.GetTimeByZone(meetingDoc[i].Slots[0], moment.tz.guess())
            ).add(parseInt(obj.MeetingSettings[0].Duration), "minutes"),
            EndTime: moment(
              self.GetTimeByZone(meetingDoc[i].Slots[0], moment.tz.guess())
            ).add(parseInt(obj.MeetingSettings[0].Duration), "minutes"),
            Email: meetingDoc[i].Invitee.Email,
            Image: meetingDoc[i].Invitee.ProfilePictureURL,
            Phone: meetingDoc[i].Invitee.Phone,
            Status: meetingDoc[i].Status,
            ReceiverId: meetingDoc[i].Invitee.AttendeeId,
            SenderId: meetingDoc[i].Requestor.AttendeeId,

            OrganizerId: meetingDoc[i].Requestor.AttendeeId,
            OrganizerEmail: meetingDoc[i].Requestor.Email,
            OrganizerFname: meetingDoc[i].Requestor.FirstName,
            OrganizerLname: meetingDoc[i].Requestor.LastName,
            Organizername: meetingDoc[i].Requestor.Name,
            Organizerprofilepic: meetingDoc[i].Requestor.ProfilePictureURL,
            OrganizerCompany: meetingDoc[i].Requestor.Company,
            OrganizerTitle: meetingDoc[i].Requestor.Designation,

            AttendeeInitials: self.getInitials(meetingDoc[i].Invitee.Name),
            OrganizerAttendeesInitials: self.getInitials(
              meetingDoc[i].Requestor.Name
            ),
            MeetingCurrentStatus: self.getMeetingCurrentStatus(
              moment(meetingDoc[i].Slots[0]).format("YYYY-MM-DDTHH:mm:ss[Z]"),
              moment(meetingDoc[i].Slots[0])
                .add(parseInt(obj.MeetingSettings[0].Duration), "minutes")
                .format("YYYY-MM-DDTHH:mm:ss[Z]")
            ),
            ShowAll: $("#customSwitch1").is(":checked"),
          });
        }
      }
    },
    bindMeetingListwithoutTimezone: function (meetingDoc) {
      let i;
      const obj = JSON.parse(window.localStorage["my-app"]);
      for (i = 0; i <= meetingDoc.length - 1; i++) {
        self.attendeeData.push({
          MeetingId: meetingDoc[i].MeetingId,
          MeetingType: meetingDoc[i].MeetingType,
          Message: meetingDoc[i].Message,
          Name: meetingDoc[i].Invitee.Name,
          Company: meetingDoc[i].Invitee.Company,
          Title: meetingDoc[i].Invitee.Designation,
          StartDate: moment(meetingDoc[i].Slots[0]).format("ddd D MMM"),
          StartTime: moment(meetingDoc[i].Slots[0]).format("hh:mm A"),
          StartDateTime: moment(meetingDoc[i].Slots[0]),
          EndDateTime: moment(meetingDoc[i].Slots[0]).add(
            parseInt(obj.MeetingSettings[0].Duration),
            "minutes"
          ),
          EndTime: moment(meetingDoc[i].Slots[0])
            .add(parseInt(obj.MeetingSettings[0].Duration), "minutes")
            .format("hh:mm A"),
          Email: meetingDoc[i].Invitee.Email,
          Image: meetingDoc[i].Invitee.ProfilePictureURL,
          Phone: meetingDoc[i].Invitee.Phone,
          Status: meetingDoc[i].Status,
          ReceiverId: meetingDoc[i].Invitee.AttendeeId,
          SenderId: meetingDoc[i].Requestor.AttendeeId,

          OrganizerId: meetingDoc[i].Requestor.AttendeeId,
          OrganizerEmail: meetingDoc[i].Requestor.Email,
          OrganizerFname: meetingDoc[i].Requestor.FirstName,
          OrganizerLname: meetingDoc[i].Requestor.LastName,
          Organizername: meetingDoc[i].Requestor.Name,
          Organizerprofilepic: meetingDoc[i].Requestor.ProfilePictureURL,
          OrganizerCompany: meetingDoc[i].Requestor.Company,
          OrganizerTitle: meetingDoc[i].Requestor.Designation,

          AttendeeInitials: self.getInitials(meetingDoc[i].Invitee.Name),
          OrganizerAttendeesInitials: self.getInitials(
            meetingDoc[i].Requestor.Name
          ),
          //moment.utc(new Date(SelDateTime)).format('YYYY-MM-DDTHH:mm:ss+00:00')
          MeetingCurrentStatus: self.getMeetingCurrentStatus(
            moment(meetingDoc[i].Slots[0]).format("YYYY-MM-DDTHH:mm:ss"),
            moment(meetingDoc[i].Slots[0])
              .add(parseInt(obj.MeetingSettings[0].Duration), "minutes")
              .format("YYYY-MM-DDTHH:mm:ss")
          ),
          ShowAll: $("#customSwitch1").is(":checked"),
        });
      }
    },
    AddToGoogleCalendar(data, type) {
      var dtFrom = this.getCalendarDateTime(
        moment.duration(data.StartDateTime._d).asSeconds(),
        "google"
      );
      var dtTo = this.getCalendarDateTime(
        moment.duration(data.EndDateTime._d).asSeconds(),
        "google"
      );
      var name;
      var company;
      var email;
      if (type == 2) {
        name = data.Name;
        company = data.Company;
        email = data.Email;
      } else {
        name = data.Organizername;
        company = data.OrganizerCompany;
        email = data.OrganizerEmail;
      }
      if (data.Message !== "") {
        return (
          "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=" +
          dtFrom +
          "/" +
          dtTo +
          "&text=" +
          "Meeting With " +
          name +
          "&details=" +
          "Meeting With: " +
          name +
          "<br>" +
          "Company: " +
          company +
          "<br>" +
          "Email: " +
          email +
          "<br>" +
          "Message: " +
          data.Message +
          "<br>" +
          "Visit " +
          location.origin.toLowerCase() +
          "/mymeetings" +
          " to check the status of all your meetings."
        );
      } else {
        return (
          "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=" +
          dtFrom +
          "/" +
          dtTo +
          "&text=" +
          "Meeting With " +
          name +
          "&details=" +
          "Meeting With: " +
          name +
          "<br>" +
          "Company: " +
          company +
          "<br>" +
          "Email: " +
          email +
          "<br>" +
          "Visit " +
          location.origin.toLowerCase() +
          "/mymeetings" +
          " to check the status of all your meetings."
        );
      }
    },
    AddToOutlookCalendar(data, type) {
      var dtFrom = this.getCalendarDateTime(
        moment.duration(data.StartDateTime._d).asSeconds(),
        "outlook"
      );
      var dtTo = this.getCalendarDateTime(
        moment.duration(data.EndDateTime._d).asSeconds(),
        "outlook"
      );
      var name;
      var company;
      var email;
      if (type == 2) {
        name = data.Name;
        company = data.Company;
        email = data.Email;
      } else {
        name = data.Organizername;
        company = data.OrganizerCompany;
        email = data.OrganizerEmail;
      }
      var linkUrl = "";
      if (data.Message !== "") {
        linkUrl =
          "start=" +
          dtFrom +
          "&end=" +
          dtTo +
          "&title=" +
          "Meeting With " +
          name +
          "&description=" +
          "Email: " +
          email +
          " Message: " +
          data.Message +
          " Visit " +
          location.origin.toLowerCase() +
          "/mymeetings" +
          " to check the status of all your meetings." +
          "&service=outlook";
        return linkUrl;
      } else {
        linkUrl =
          "start=" +
          dtFrom +
          "&end=" +
          dtTo +
          "&title=" +
          "Meeting With " +
          name +
          "&description=" +
          "Meeting With: " +
          name +
          " Company: " +
          company +
          " Email: " +
          email +
          " Visit " +
          location.origin.toLowerCase() +
          "/mymeetings" +
          " to check the status of all your meetings." +
          "&service=outlook";

        linkUrl =
          "https://www.addevent.com/dir/?client=amFHciuoCzziVYGDHmDp105401&" +
          linkUrl;

        // linkUrl =
        //   "https://www.addevent.com/dir/?client=amFHciuoCzziVYGDHmDp105401" +
        //   "&subject=" +
        //   "Meeting With " +
        //   name +
        //   "&body=" +
        //   "Meeting With: " +
        //   name +
        //   "<br>" +
        //   "Company: " +
        //   company +
        //   "<br>" +
        //   "Email: " +
        //   email +
        //   "<br>" +
        //   "Visit " +
        //   location.origin.toLowerCase() +
        //   "/mymeetings" +
        //   " to check the status of all your meetings.";
        // "&startdt=" +
        //   dtFrom +
        //   "&enddt=" +
        //   dtTo +
        //   "&uid=1a45242b-5205-4f37-815a-84ab74990640&allday=false&path=/calendar/action/compose";
        return linkUrl;
      }
    },
  },
  beforeDestroy() {
    if(interval) {
      clearInterval(interval);
      interval = null;
    }
  },
  async mounted() {
    $(".modal-backdrop").hide();
    if (screen.width >= 768 && screen.width <= 1024) {
      common.checkAppDownloadScreenByDevice("ipad");
    } else if (screen.width < 767) {
      common.checkAppDownloadScreenByDevice("mobile");
    }
    //$("#topmenu").show();

    //$("#leftmenu").show();

    // if ($("#ulLeftMenu li").length > 0) {
    //   $("#leftMenuParent").show();
    //   $("#leftmenu").show();
    // } else {
    //   $("#leftMenuParent").hide();
    //   $("#leftmenu").hide();
    // }
    $("#btnAddUserView").click();
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    //-------------dynamic font selection --------------------------------------
    //-------------dynamic font selection --------------------------------------
    if (obj.EventFont != undefined) {
      if (obj.EventFont.length > 0) {
        //
        var urlpath = "";
        if (obj.EventFont[0].FontPath != "") {
          if (obj.EventFont[0].FontFamily != "") {
            urlpath = obj.EventFont[0].FontPath;

            var newStyle = document.createElement("style");
            newStyle.appendChild(
              document.createTextNode(
                "\
@font-face {\
    font-family: " +
                  obj.EventFont[0].FontFamily +
                  ";\
    src:" +
                  urlpath +
                  " ;\
}\
"
              )
            );

            document.head.appendChild(newStyle);

            $(
              "<style>* { font-family: '" +
                obj.EventFont[0].FontFamily +
                "' !important }</style>"
            ).appendTo("head");
          }
        } else {
          $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
            "head"
          );
        }
      }
    }
    //-------------dynamic font selection --------------------------------------
    //-------------dynamic font selection --------------------------------------
    //-------Page Title-------------

    db.collection(obj.eventcollectionname)
      .doc("Menu")
      .get()
      .then((doc) => {
        var data = doc.data();
        $.each(data.AllMenu, function (key, value) {
          if (value.GroupID != 99) {
            if (value.Name == "OneToOneMeeting") {
              if (self.$store.state.locale == "English") {
                self.headerText = value.DisplayLabel;
              } else if (self.$store.state.locale == "German") {
                self.headerText = value.DisplayLabel_de;
              } else if (self.$store.state.locale == "French") {
                self.headerText = value.DisplayLabel_fr;
              } else if (self.$store.state.locale == "Chinese") {
                self.headerText = value.DisplayLabel_zh;
              } else {
                self.headerText = value.DisplayLabel;
              }
            }
          }
        });
        $.each(data.AllMenu, function (key, value) {
          if (value.GroupID != 99) {
            if (value.Name == "OneToOneMeeting") {
              if (self.$store.state.locale == "English") {
                self.headerText = value.DisplayLabel;
              } else if (self.$store.state.locale == "German") {
                self.headerText = value.DisplayLabel_de;
              } else if (self.$store.state.locale == "French") {
                self.headerText = value.DisplayLabel_fr;
              } else if (self.$store.state.locale == "Chinese") {
                self.headerText = value.DisplayLabel_zh;
              } else {
                self.headerText = value.DisplayLabel;
              }
            }
          }
        });
      });

    var brandingData;
    try {
      brandingData = await self.getBrandingJSONDetails(
        obj.eventcollectionname + "/Branding/Branding.json"
      );
      if (brandingData.data != undefined) {
        if (brandingData.data.EventInfo != undefined) {
          if (brandingData.data.EventInfo.BodyTextColor != undefined) {
            self.textColor = brandingData.data.EventInfo.BodyTextColor;
          } else {
            self.textColor = "black";
          }
        } else {
          self.textColor = "black";
        }
        console.log("BodyTextColor :- " + self.textColor);
        $("#headerText").css("color", self.textColor);
      }
    } catch (e) {
      console.log("Error in Branding Json Fetch--", e);
    }

    //---------------------------------------------------
    //-------------------FAVICONJOB------------------------------------------------------------
    //
    if (obj.branding[0].favicon != undefined) {
      if (obj.branding[0].favicon != "") {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = obj.branding[0].favicon;
        document.getElementsByTagName("head")[0].appendChild(link);
      }
    }
    //----------------------------------------------------------------------------------
    $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);
    $("#sectionId").css(
      "background-image",
      "url(" + obj.EventBranding[0].eventBGImage + ")"
    );
    $("#divnomeetings").hide();
    self.attendeeData = [];
    self.setFirebaseAppsettings();

    self.getMeetingList();
    //self.displayAttendees();
    //self.scroll();

    interval = setInterval(() => {
      self.getMeetingList();
    }, 5000);

    //-------Search part------------------------------------------------
    $("#InputSearch").keyup(function () {
      //
      $("#spnHeaderText").html("");
      // Retrieve the input field text and reset the count to zero
      var filter = $(self).val(),
        count = 0;
      // Loop through the comment list
      $("#divMainiRow div").each(function () {
        let self = self;
        // If the list item does not contain the text phrase fade it out
        if ($(self).text().search(new RegExp(filter, "i")) < 0) {
          $(self).hide();
          // Show the list item if the phrase matches and increase the count by 1
        } else {
          $(self).show();

          count++;
        }
      });
      if (count <= 0) {
        $("#spnHeaderText").html("No matches found");
      } else {
        $("#spnHeaderText").html("");
      }
    });
    //
    $("#listing-view").click(function () {
      //alert("click");
      $(".meeding-grid ul li").removeClass("active");
      $(this).addClass("active");
      $(".meeting-box-hld").addClass("listing-view-box");
    });
    $("#grid-view").click(function () {
      $(".meeding-grid ul li").removeClass("active");
      $(this).addClass("active");
      $(".meeting-box-hld").removeClass("listing-view-box");
    });

    //---------------------------------------------------
  },
};
</script>   

<style lang="scss" scoped>
.meeting-box-hld:empty {
  display: none;
}
.accept-btn {
  border: 1px solid #1dc190;
  color: #1dc190;
}
button.btn-rounded.cancle-circle {
  border: 1px solid #f2f2f2;
  color: gray;
}

.dvEnded {
  display: none;
}

.dvtoShow {
  display: block;
}
.no-meeting-paragraph {
  font-weight: 400;
  font-size: 16px;
  color: #333;
  margin: 0px !important;
}
.no-meeting-text {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  position: relative;
}
.no-meeting-paragraph span:hover {
  text-decoration: underline;
}
.exhibitors-popup .meeting-list.attendee-list .listing-view-box {
  margin: 0px;
  margin-bottom: 10px;
  padding: 0;
}
.exhibitors-popup
  .meeting-list.attendee-list
  .listing-view-box
  .sponsors-box-hld {
  flex-direction: column;
  margin-bottom: 0px;
}
.exhibitors-popup .container-fluid {
  padding: 0;
}
.exhibitors-popup .redsn-evnts-col.bottom-line {
  //border-top: 1px solid #ccc;
  //border-radius: 0 !important;
  position: relative;
}
.exhibitors-popup .redsn-evnts-col.bottom-line:after {
  content: "";
  position: absolute;
  width: 89%;
  top: 0;
  height: 1px;
  background: #cbcbcb;
  right: 15px;
}
.meeting-list.attendee-list .listing-view-box .sponsors-box-hld {
  border-radius: 8px;
}
.right-pannel-wrapper .meeting-box-hld.listing-view-box span.attendee-img-area {
  max-height: 36px !important;
  min-height: 36px !important;
  height: 36px !important;
  max-width: 36px !important;
  min-width: 36px !important;
  width: 36px !important;
  font-size: 16px !important;
  background-color: transparent !important;
}
.right-pannel-wrapper
  .meeting-box-hld.listing-view-box
  span.attendee-img-area
  img {
  max-height: 36px !important;
  min-height: 36px !important;
  height: 36px !important;
  max-width: 36px !important;
  min-width: 36px !important;
  width: 36px !important;
}
.right-pannel-wrapper
  .meeting-box-hld.listing-view-box
  span.attendee-img-area.initial {
  border: 2px solid #fff !important;
  color: #fff !important;
}
.right-pannel-wrapper .meeting-box-hld.listing-view-box {
  background-color: #232a2e;
}
.right-pannel-wrapper .meeting-box-hld.listing-view-box * {
  background-color: transparent;
}
.right-pannel-wrapper
  .meeting-box-hld.listing-view-box
  .grey-bg-texthld.attendee {
  color: #fff;
}
.right-pannel-wrapper
  .meeting-box-hld.listing-view-box
  .grey-bg-texthld.attendee
  h4 {
  color: #fff;
}
.right-pannel-wrapper .meeting-box-hld.listing-view-box .grey-bg-texthld h4 {
  font-size: 16px;
}
.right-pannel-wrapper .meeting-box-hld.listing-view-box .grey-bg-texthld p {
  font-size: 14px;
}
.right-pannel-wrapper .session-status p {
  color: #7f838c;
}
.right-pannel-wrapper .status.redsn-evnts-col h5.ico-calender-sm,
.right-pannel-wrapper .status.redsn-evnts-col p.ico-pin-sm {
  color: #7f838c;
}
.right-pannel-wrapper .btn-rounded.j-meeting-btn {
  background: #669c10;
  border: 0px;
  border-radius: 5px;
  color: #fff;
  padding: 8px;
  margin-left: 0px;
  cursor: pointer;
  font-weight: 600;
  font-size: 15px;
  margin-top: 5px;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
}
.ex-no-meeting-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.right-pannel-wrapper .ex-no-meeting-wrap {
  max-height: 400px;
}
.right-pannel-wrapper p.ex-no-meeting-text {
  color: #8b8d90;
}
</style>
